<template>
  <Wrapper>
    <Dashboard>
      <Settings />
    </Dashboard>
  </Wrapper>
</template>

<script setup lang="ts">
import Settings from '@/components/dashboard/Settings.vue'
import Dashboard from '@/components/wrappers/Dashboard.vue'
import Wrapper from '@/components/wrappers/Wrapper.vue'

definePage({
  name: 'settings',
  meta: {
    titleKey: 'tab.settings',
    requiresAuth: true,
  },
})
</script>
